<template>
  <div class="content-box">
    <div class="top">
      <div class="left-width banners">
        <el-carousel trigger="click" class="carousel" height="100%">
          <el-carousel-item v-for="item in list" :key="item.url">
            <img :src="baseURL+'/'+item.url">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="banners right-width">
        <div class="right-box">
          <div class="right-title">RESEARCH TOPICS</div>
          <img :src="baseURL+'/'+right.url" style="cursor: pointer" @click="rightClick">
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left-width">
        <div class="title">Links</div>
        <div class="line-box">
          <div class="line" />
          <div class="bar" />
        </div>
        <div class="links">
          <div class="link">
            <a href="http://www.med.tsinghua.edu.cn/" target="_blank"><img src="../assets/link1.png"></a>
            <div>清华大学医学院</div>
          </div>
          <div class="link">
            <a href="http://life.tsinghua.edu.cn/" target="_blank"><img src="../assets/link2.png"></a>
            <div>清华大学生命科学学院</div>
          </div>
          <div class="link">
            <a href="http://www.icsb.tsinghua.edu.cn/" target="_blank"><img src="../assets/link3.png"></a>
            <div>结构生物学</div>
            <div>高精尖创新中心</div>
          </div>
          <div>
            <a href="http://www.cls.edu.cn/" target="_blank"><img style="width: 160px;height: 64px" src="../assets/link4.png"></a>
            <div>生命科学联合中心</div>
          </div>
        </div>
      </div>
      <div class="right-width">
        <div class="title">Contact Us</div>
        <div class="line-box">
          <div class="line" />
          <div class="bar" style="width: 76px" />
        </div>
        <div class="contact">
          <p>Medical Science Building D108<br>
            Tsinghua University<br>
            Beijing, 100084, China</p>
          <p>Email: xshen@tsinghua.edu.cn</p>
          <p>Tel: 86-10-6279-8513</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_API,
      list: [],
      right: {}
    }
  },
  created() {
    this.$axios.get(this.$api.listBanner).then(res => {
      this.list = res.data.filter(v => v.position === 1)
      this.right = res.data.filter(v => v.position === 2)[0]
    })
  },
  methods: {
    rightClick() {
      if (this.right.filePath) {
        window.open(this.baseURL + '/' + this.right.filePath, '_blank')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.top
  margin-top 40px
  width 100%
  display flex
  justify-content space-between
  margin-bottom 45px

  img
    object-fit cover
    width 100%
    height 100%

  .banners
    height 0
    padding-bottom 43.6%
    position relative

  .carousel
    width 100%
    height 100%
    position absolute
    border-radius 20px

  .right-box
    width 100%
    height 100%
    position absolute
    display flex
    flex-direction column

    img
      flex 1
      height auto

  .right-title
    border-radius: 20px 20px 0 0
    background: rgba(44, 61, 103, 1)
    font-size: 28px
    color white
    text-align center
    height 71px
    line-height 71px

  /deep/ .el-carousel__button
    height 4px
    border-radius 3px

.left-width
  width 54.9%

.right-width
  width 43.3%

.bottom
  width 100%
  display flex
  justify-content space-between

  .title
    font-size 20px
    font-weight 600
    color rgba(31, 46, 65, 1)
    margin-bottom 12px

  .line-box
    width 100%
    position relative
    .line
      width 100%
      height 1px
      background rgba(31, 46, 65, 1)
      opacity 0.2
    .bar
      width 55px
      height 5px
      background rgba(203, 214, 255, 1)
      border-radius 0 71px 0 0
      position absolute
      bottom 1px
      opacity 1.0

  .links
    margin-top 34px
    margin-bottom 32px
    display flex
    font-size 12px
    color rgba(109,109,109,1)
    text-align center
    img
      margin-bottom 9px
      width 80px
      height 80px
    .link
      margin-right 8px

  .contact
    margin-top 7px
    font-size 14px
    color rgba(31,46,65,1)
    p
      margin-top 0
      margin-bottom 10px
</style>
